"use strict";

var _classCallCheck = require("/home/utils/ponder/landing/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/utils/ponder/landing/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DivEvent = void 0;

var Enums_1 = require("../../../../Enums");

var DivEvent = /*#__PURE__*/function () {
  function DivEvent() {
    _classCallCheck(this, DivEvent);

    this.selectors = [];
    this.enable = false;
    this.mode = [];
    this.type = Enums_1.DivType.circle;
  }

  _createClass(DivEvent, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      var ids = (_b = (_a = data.ids) !== null && _a !== void 0 ? _a : data.elementId) !== null && _b !== void 0 ? _b : data.el;

      if (ids !== undefined) {
        this.ids = ids;
      }

      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }, {
    key: "elementId",
    get: function get() {
      return this.ids;
    },
    set: function set(value) {
      this.ids = value;
    }
  }, {
    key: "el",
    get: function get() {
      return this.elementId;
    },
    set: function set(value) {
      this.elementId = value;
    }
  }, {
    key: "ids",
    get: function get() {
      if (this.selectors instanceof Array) {
        return this.selectors.map(function (t) {
          return t.replace("#", "");
        });
      } else {
        return this.selectors.replace("#", "");
      }
    },
    set: function set(value) {
      if (value instanceof Array) {
        this.selectors = value.map(function (t) {
          return "#".concat(t);
        });
      } else {
        this.selectors = "#".concat(value);
      }
    }
  }]);

  return DivEvent;
}();

exports.DivEvent = DivEvent;